import React, { useEffect, useState } from "react"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { CountryPicker } from "../../../common/element/fields/CountryPicker"
import { ICountry } from "../../../../types/dict/ICountry"
import { SwiftPicker } from "../../../common/element/fields/SwiftPicker"
import { CurrencyPicker } from "../../../common/element/fields/CurrencyPicker"
import { ISwift } from "../../../../types/dict/ISwift"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IClientContractorDto } from "../../../../types/contractor/IClientContractorDto"
import { IClientContractorAccountDto } from "../../../../types/contractor/IClientContractorAccountDto"
import Button from "@/ui/components/Button"

export const ContractorTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: () => void
}> = ({ replenishment, setReplenishment, errorModel, sending, submit }) => {
  const [contractors, setContractors] = useState<IClientContractorDto[]>([])
  const [filteredContractors, setFilteredContractors] = useState<IClientContractorDto[]>([])
  const [pickedContractor, setPickedContractor] = useState<IClientContractorDto>()
  const [pickedContractorAccounts, setPickedContractorAccounts] = useState<IClientContractorAccountDto[]>([])
  const [pickedContractorAccount, setPickedContractorAccount] = useState<IClientContractorAccountDto>()
  const [currentAccountIndex, setCurrentAccountIndex] = useState(0)
  const [searchQuery, setSearchQuery] = useState<string | undefined>()
  const [payerCompanyName, setPayerCompanyName] = useState<string>("")

  useEffect(() => {
    getContractors()
  }, [])

  useEffect(() => {
    if (replenishment.clientRequestId) {
      TrinityAPI.getClientRequest(Number(replenishment.clientRequestId), response => {
        if (response.status === 200) {
          setPayerCompanyName(response.data.clientCompanyName)
        }
      })
    }
  }, [replenishment])

  useEffect(() => {
    if (!searchQuery || searchQuery.length < 3) {
      setFilteredContractors([])
      return
    }
    if (searchQuery?.length >= 3) {
      setFilteredContractors(
        contractors.filter(
          c =>
            c.name?.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase()) ||
            (c.country &&
              c.country.name &&
              c.country.name.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ||
            (c.accounts &&
              c.accounts.length > 0 &&
              c.accounts.filter(a => a.swift?.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())).length >
                0) ||
            (c.accounts &&
              c.accounts.length > 0 &&
              c.accounts.filter(a => a.currency?.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())).length >
                0)
        )
      )
    }
  }, [searchQuery])

  useEffect(() => {
    if (pickedContractor && pickedContractor.id) {
      TrinityAPI.getClientContractor(pickedContractor.id, response => {
        if (response.status === 200) {
          setPickedContractorAccounts(response.data.accounts || new Array([]))
          setReplenishment({
            ...replenishment,
            contractorId: pickedContractor.id,
            contractorName: pickedContractor.name,
            contractorCountry: pickedContractor.country,
            contractorAddress: pickedContractor.address,
            contractorContactName: pickedContractor.contactName,
            contractorContactPhone: pickedContractor.contactPhone,
            contractorContactEmail: pickedContractor.contactEmail,
            contractorContactJobTitle: pickedContractor.contactJobTitle
          })
        }
      })
    }
  }, [pickedContractor])

  useEffect(() => {
    if (pickedContractorAccounts.length && !pickedContractorAccount) {
      setPickedContractorAccount(pickedContractorAccounts[0])
    }
  }, [pickedContractorAccounts])

  useEffect(() => {
    if (pickedContractorAccount) {
      setReplenishment({
        ...replenishment,
        contractorSwift: pickedContractorAccount.swift,
        contractorCurrency: pickedContractorAccount.currency,
        contractorAccountNumber: pickedContractorAccount.accountNumber,
        contractorBankName: pickedContractorAccount.bankName
      })
    }
  }, [pickedContractorAccount])

  const getContractors = () => {
    TrinityAPI.getClientContractors(response => {
      if (response.status === 200) {
        setContractors(response.data)
      }
    })
  }

  const changeCountry = (countryList: ICountry[]) => {
    if (countryList.length === 0) {
      setReplenishment({ ...replenishment, contractorCountry: undefined })
    } else {
      setReplenishment({ ...replenishment, contractorCountry: countryList[0] })
    }
  }

  const changeSwift = (swift: ISwift | undefined) => {
    if (swift) {
      setReplenishment({ ...replenishment, contractorSwift: swift.swift_code, contractorBankName: swift.bank_name })
    }
  }

  const pickContractor = (contractor: IClientContractorDto) => {
    setFilteredContractors([])
    setPickedContractor(contractor)
  }

  const pickAccount = (account: IClientContractorAccountDto, index: number) => {
    setCurrentAccountIndex(index)
    setPickedContractorAccount(account)
  }

  // const clearAll = () => {
  //   setSearchQuery(undefined)
  //   setFilteredContractors([])
  //   setPickedContractor(undefined)
  //   setPickedContractorAccount(undefined)
  //   setPickedContractorAccounts([])
  // }

  const isEditable = () => {
    return replenishment.status === "DOC_NAC" || replenishment.status === "NEW"
  }

  return (
    <>
      <div
        className="container"
        style={!isEditable() ? { pointerEvents: "none", opacity: 0.7 } : {}}
        aria-disabled={replenishment.status === "DOC_REVIEW"}
      >
        <div className="container-pop-up">
          <div className="form-block-popup width-full">
            <h4 className="heading-chapter">Поиск контрагента</h4>
            <fieldset>
              <input
                type="search"
                className="input-form-search width-full"
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Поиск по названию, стране, SWIFT или валюте"
              />
              <ul className="prompt-list">
                {filteredContractors?.map((c: IClientContractorDto, index: number) => (
                  <li className="promp-item" key={index} onClick={() => pickContractor(c)}>
                    {c.name}
                  </li>
                ))}
              </ul>
            </fieldset>
            {pickedContractor && pickedContractorAccounts.length > 0 ? (
              <>
                <li className="form-block-popup">
                  <h4 className="heading-chapter">Выберите счет</h4>
                  <div className="flex-row-10 flex-wrap-mobile">
                    {pickedContractorAccounts.map((account: IClientContractorDto, index: number) => (
                      <button
                        className={`btn ${
                          pickedContractorAccount && pickedContractorAccount.id === account.id
                            ? "black-btn"
                            : "grey-btn"
                        } btn-bank-account`}
                        key={index}
                        onClick={() => pickAccount(account, index)}
                      >
                        Счет {index + 1}
                      </button>
                    ))}
                  </div>
                  {pickedContractorAccounts.map((a, index) => (
                    <React.Fragment key={index}>
                      <div
                        className="flex-row-10 flex-wrap-mobile"
                        style={{ display: index === currentAccountIndex ? "" : "none" }}
                      >
                        <fieldset>
                          <legend>SWIFT</legend>
                          <p className="text-form">{a.swift}</p>
                        </fieldset>
                        <fieldset>
                          <legend>IBAN</legend>
                          <p className="text-form">{a.accountNumber}</p>
                        </fieldset>
                      </div>
                      <div
                        className="flex-row-10 flex-wrap"
                        style={{ display: index === currentAccountIndex ? "" : "none" }}
                      >
                        <fieldset style={{ display: index === currentAccountIndex ? "" : "none" }}>
                          <legend>Банк</legend>
                          <p className="text-form">{a.bankName}</p>
                        </fieldset>
                        <fieldset className="fieldset-200">
                          <legend>Валюта</legend>
                          <p className="text-form">{a.currency}</p>
                        </fieldset>
                      </div>
                    </React.Fragment>
                  ))}
                </li>
                {/*<div className="flex-row-10">*/}
                {/*  <button className="btn grey-btn" onClick={clearAll}>Отменить и очистить форму</button>*/}
                {/*</div>*/}
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Получатель валютных средств</h4>
                {replenishment.contractorComment ? (
                  <p className="message-course-no">{replenishment.contractorComment}</p>
                ) : (
                  <></>
                )}
                <CommonInput
                  typeName={"text"}
                  label={"Полное название"}
                  placeholder={"Название компании"}
                  name={"contractorName"}
                  value={replenishment.contractorName}
                  errorModel={errorModel}
                  _callback={e => setReplenishment({ ...replenishment, contractorName: e })}
                />
                <CountryPicker
                  label={"Страна"}
                  value={replenishment.contractorCountry ? new Array(replenishment.contractorCountry) : []}
                  size={1}
                  name={"contractorCountry"}
                  errorModel={errorModel}
                  _callback={changeCountry}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Адрес"}
                  placeholder={"Адрес компании"}
                  name={"contractorAddress"}
                  value={replenishment.contractorAddress}
                  errorModel={errorModel}
                  _callback={e =>
                    setReplenishment({
                      ...replenishment,
                      contractorAddress: e
                    })
                  }
                />
              </li>

              <li className="form-block-popup">
                <h4 className="heading-chapter">Счет</h4>
                {replenishment.contractorBankComment ? (
                  <p className="message-course-no">{replenishment.contractorBankComment}</p>
                ) : (
                  <></>
                )}
                <div className="flex-row-10 flex-wrap-mobile">
                  <SwiftPicker
                    label={"SWIFT"}
                    name={"contractorSwift"}
                    value={replenishment.contractorSwift}
                    errorModel={errorModel}
                    _callback={changeSwift}
                  />
                  <CommonInput
                    typeName={"text"}
                    label={"IBAN"}
                    placeholder={"Введите номер счета"}
                    name={`contractorAccountNumber`}
                    value={replenishment.contractorAccountNumber}
                    errorModel={errorModel}
                    _callback={e =>
                      setReplenishment({
                        ...replenishment,
                        contractorAccountNumber: e
                      })
                    }
                  />
                </div>
                <div className="flex-row-10 flex-wrap-mobile">
                  <CommonInput
                    typeName={"text"}
                    label={"Банк"}
                    placeholder={"Название банка"}
                    name={`contractorBankName`}
                    value={replenishment.contractorBankName}
                    errorModel={errorModel}
                    _callback={e => setReplenishment({ ...replenishment, contractorBankName: e })}
                  />
                  <CurrencyPicker
                    label={"Валюта счета"}
                    name={`contractorCurrency`}
                    errorModel={errorModel}
                    initValue={replenishment.contractorCurrency}
                    _callback={e => setReplenishment({ ...replenishment, contractorCurrency: e })}
                    clazzName={"fieldset-200"}
                  />
                </div>
              </li>
            </ul>

            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Название компании плательщика</h4>
                <fieldset>
                  <legend>Полное название</legend>
                  <p className="text-form">{payerCompanyName}</p>
                </fieldset>
              </div>

              <div className="form-block-popup">
                <h4 className="heading-chapter">Контакты</h4>
                {replenishment.contractorContactComment ? (
                  <p className="message-course-no">{replenishment.contractorContactComment}</p>
                ) : (
                  <></>
                )}
                <CommonInput
                  typeName={"text"}
                  label={"ФИО"}
                  placeholder={"ФИО"}
                  name={"contractorContactName"}
                  value={replenishment.contractorContactName}
                  errorModel={errorModel}
                  _callback={e => setReplenishment({ ...replenishment, contractorContactName: e })}
                />
                {/*<CommonInput*/}
                {/*    typeName={"text"}*/}
                {/*    label={"Должность"}*/}
                {/*    placeholder={"Должность"}*/}
                {/*    name={"contractorContactJobTitle"}*/}
                {/*    value={replenishment.contractorContactJobTitle}*/}
                {/*    errorModel={errorModel}*/}
                {/*    _callback={(e) => setReplenishment({...replenishment, contractorContactJobTitle: e})}/>*/}
                <div className="flex-row-10 flex-wrap">
                  {/*<CommonInput*/}
                  {/*    typeName={"text"}*/}
                  {/*    label={"Email"}*/}
                  {/*    placeholder={"mail@mail.com"}*/}
                  {/*    name={"contractorContactEmail"}*/}
                  {/*    value={replenishment.contractorContactEmail}*/}
                  {/*    errorModel={errorModel}*/}
                  {/*    _callback={(e) => setReplenishment({...replenishment, contractorContactEmail: e})}/>*/}
                  <CommonInput
                    typeName={"text"}
                    label={"Телефон"}
                    placeholder={"+7 200 000 00 00"}
                    name={"contractorContactPhone"}
                    value={replenishment.contractorContactPhone}
                    errorModel={errorModel}
                    _callback={e => setReplenishment({ ...replenishment, contractorContactPhone: e })}
                  />
                </div>
              </div>
            </div>
          </div>
          {isEditable() && (
            <div className="flex-row-10">
              <Button loading={sending} onClick={submit}>
                Далее
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
